import { AtributoCGR } from './AtributoCGR';

export class DocumentoCGR {
    rutaArchivoPlantilla: string; // "C:\\\\archivos\\\\",
    nombreArchivoPlantilla: string; // "OFICIO.DOCX",
    rutaArchivoGenerado: string; // "C:/archivos/",
    nombreArchivoGenerado: string; // "oficioGeneradoCGR.docx",
    nombrePdfGenerado: string;
    tipoDocumento: string;
    datos: AtributoCGR[];

}

